/**
 * An entrance's delay in a staggered set: the reference's base and step, which Keystone's pages shorten and cap
 * (kit.css: `--stagger-base`, `--stagger-step`, `--stagger-cap`) so the last item of any set has started by 100 ms
 * and landed by 300 ms. The replica keeps the reference's own sequence.
 */
export const stagger = (index: number, step: number, base = 0): string =>
  `min(calc(${base}ms * var(--stagger-base, 1) + ${index * step}ms * var(--stagger-step, 1)), var(--stagger-cap, 60s))`;
